export default __webpack_public_path__ + "static/media/bol_3.b32a0ccd.svg";